// extracted by mini-css-extract-plugin
module.exports = {"custom":"custom-module__custom--3xMyO"};